import { useEffect } from 'react';
import { useFile } from '../../../File';
import { File as GQLFile } from '../../../generated/graphql';

/**
 * downloadURL is a short-lived signed URL, so the currently displayed file's
 * URL is refetched whenever it becomes the displayed file (mount, or after
 * paging to it) rather than trusting the URL on the `File` the caller passed in.
 */
export const useDocumentViewerFile = (tenantID: string, file: Pick<GQLFile, 'id'>) => {
  const { file: refreshedFile, fileQuery } = useFile(tenantID, file.id, { enabled: false, retry: false });

  useEffect(() => {
    void fileQuery.refetch();
    // fileQuery is a new object each render; only re-run when the file being viewed changes.
  }, [tenantID, file.id]);

  return {
    downloadURL: refreshedFile?.downloadURL ?? undefined,
    isLoading: fileQuery.isLoading || fileQuery.isFetching,
    isError: fileQuery.isError,
    retry: () => void fileQuery.refetch(),
  };
};
